export default class extends Controller {
  connect() {
    this.removeListItem = this.removeListItem.bind(this)
    App.Helpers.listenToCustomEvent(document, "schedulables:delete-success", this.removeListItem)
  }

  removeListItem(event) {
    const { schedulableID, all, isRepeat } = event.detail
    if (all || App.Helpers.falsyValues.includes(isRepeat)) {
      const row = this.element.querySelector(`[data-record-id="${schedulableID}"]`)
      row && row.remove()
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-list-controller.js